import { gql } from "@apollo/client";

export const GET_ALIMENTACION_PARENTERAL_CONTRATO = gql`
    query AlimentacionParenteralRIByEvaluacionId (
        $idEvaluacion: Int!
    ) {
        alimentacionParenteralRIByEvaluacionId (
            idEvaluacion: $idEvaluacion
        ){           
            volumenMagistral
            idComboRIValorModoInfusion
            idComboRIValorSelladoCateter
            diaConexionMagistral
            diaConexionEstandar
        }
    }
`;

export const adaptAlimentacionParenteralContrato = ({ alimentacionParenteralRIByEvaluacionId }) => {
  return {
    volumenMagistral: alimentacionParenteralRIByEvaluacionId?.volumenMagistral,
    idComboRIValorModoInfusion: alimentacionParenteralRIByEvaluacionId?.idComboRIValorModoInfusion,
    idComboRIValorSelladoCateter: alimentacionParenteralRIByEvaluacionId?.idComboRIValorSelladoCateter,
    diaConexionRIMagistral: alimentacionParenteralRIByEvaluacionId?.diaConexionMagistral,
    diaConexionRIEstandar: alimentacionParenteralRIByEvaluacionId?.diaConexionEstandar
  };
};